import React from "react";
import Svg, { ClipPath, Defs, G, Path, Rect } from "react-native-svg";

type Avatar12Colors = {
  background?: string;
  skin?: string;
  hair?: string;
};

export const Avatar12 = ({
  colors = {},
  size = 96,
}: {
  colors?: Avatar12Colors;
  size?: number | string;
}) => {
  const c = {
    background: colors.background ?? "#fff",
    skin: colors.skin ?? "#fff",
    hair: colors.hair ?? "#fff",
  };
  return (
    <Svg width={size} height={size} viewBox="0 0 304 304" fill="none">
      <G id="avatar12" clipPath="url(#clip0_2446_10798)">
        <Path
          id="background"
          d="M151.833 303.667c83.856 0 151.834-67.978 151.834-151.834C303.667 67.978 235.689 0 151.833 0 67.978 0 0 67.978 0 151.833c0 83.856 67.978 151.834 151.833 151.834Z"
          fill={c.background}
        />
        <Path
          id="Vector"
          d="M244.606 272.019c-22.282-11.279-93.893-21.257-149.824-18.699-20.629.946-35.507 4.965-46.176 9.842 27.088 25.126 63.358 40.497 103.219 40.497 34.944 0 67.115-11.812 92.773-31.647l.008.007Z"
          fill="#000"
        />
        <Path
          id="skin"
          d="M182.384 254.853c-3.439-.659-.326-22.115.381-34.086 8.738 1.589 19.136 4.091 25.777-2.271 6.919-13.886 21.758-41.37 22.488-53.532.477-7.872-.929-10.843-.929-25.269.731-47.002-19.899-87.943-59.251-88.475-82.724-1.112-64.057 78.888-63.842 81.239-9.874-7.697-25.023-.429-19.605 20.335 9.23 35.381 28.001 31.441 35.484 26.317 2.685 6.045-6.299 42.427-7.102 49.521-2.208 19.398-21.003 24.688-21.003 24.688s39.52 34.388 73.208 49.489a150.651 150.651 0 0 0 34.706-7.888c1.604-14.902-1.049-36.39-20.32-40.068h.008Z"
          fill={c.skin}
        />
        <Path
          id="Vector_2"
          opacity={0.75}
          d="M181.447 240.086c.795-7.038 2.812-19.422 2.375-19.509-23.648-5.06-39.122-14.354-44.746-19.35-.008.46 13.48 33.259 42.371 38.859Z"
          fill="#2E2017"
        />
        <Path
          id="Vector_3"
          opacity={0.75}
          d="M174.655 182.726c.715.866 10.398 16.364 22.52 16.737 10.327.31 14.553-11.534 14.847-12.13 0 0-4.155-5.56-7.332-5.655-3.178-.096-5.521 1.612-5.521 1.612s-2.693-2.256-6.061-2.359c-3.368-.103-6.521 1.779-9.707 2.176-3.225.405-8.738-.381-8.738-.381h-.008Zm4.171 2.677c-.08-.063 0-.175.095-.127 3.726 1.946 10.319 3.567 20.693 3.884 5.346.159 8.889.223 11.891-.722-3.018 1.223-7.133 4.813-12.471 4.647-10.406-.318-16.586-4.949-20.208-7.682Z"
          fill="#2E2017"
        />
        <Path
          id="Vector_4"
          opacity={0.75}
          d="M191.837 169.492c-.611 2.391 2.344 3.972 12.48 3.567 8.348-.334 11.041-4.862 9.405-5.497-1.637-.636-3.837 2.208-9.27 2.208-7.928 0-11.995-2.669-12.615-.278Z"
          fill="#2E2017"
        />
        <Path
          id="Vector_5"
          d="M144.66 128.312s12.98-4.083 23.068-4.003c11.86.087 20.185 8.023 22.473 3.964.722-1.287.23-8.079-21.377-10.303-9.667-.993-15.362 3.543-24.156 10.35l-.008-.008Z"
          fill="#000"
        />
        <Path
          id="Vector_6"
          d="M186.055 143.969c-2.924-4.996-7.769-9.603-13.862-10.723-2.741-.326-5.513-.016-8.126 1-2.137.819-3.781 2.169-5.354 3.519-2.145 1.486-4.989.914-7.57.62 2.43 1.708 6.037 3.074 9 1.605.707-.453 1.39-.85 2.057-1.2-.024.215-.048.429-.048.652 0 3.971 3.337 7.196 7.443 7.196 4.107 0 7.444-3.225 7.444-7.196a7.67 7.67 0 0 0-.072-.962c2.915 1.343 5.855 3.321 9.072 5.497l.016-.008Z"
          fill="#000"
        />
        <Path
          id="Vector_7"
          d="M226.027 121.171c-14.172-.429-22.338 7.435-20.821 10.359.946 1.803 3.837 1.882 5.966-.159 5.847-5.021 9.342-3.345 15.474-3.424-.111-2.137-.421-4.989-.627-6.768l.008-.008Z"
          fill="#000"
        />
        <Path
          id="Vector_8"
          d="M232.159 140.347c-1.581-1.35-3.225-2.701-5.354-3.519-2.605-1.009-5.386-1.319-8.126-1.001-6.085 1.12-10.938 5.727-13.862 10.724 1.653-1.12 3.233-2.185 4.774-3.138.286 3.495 3.305 6.244 6.991 6.244 3.876 0 7.022-3.043 7.022-6.784a6.52 6.52 0 0 0-1.017-3.471c2.51.278 5.179 1.255 8.134 3.161 2.963 1.462 6.57.096 9-1.604-2.581.301-5.425.865-7.57-.62l.008.008Z"
          fill="#000"
        />
        <Path
          id="hair"
          d="M242.97 103.06c-9.993-33.347-40.647-63.326-73.843-59.283 3.09-15.069-9.461-22.854-9.461-22.854l.167 7.412s-4.941-15.157-13.012-16.475c-8.07-1.319-10.875 4.448-10.875 4.448s-11.2-6.093-20.264-6.093c-9.063 0-12.685 8.405-12.685 8.405s-5.934-4.616-14.831.826c-8.897 5.433-7.411 15.815-7.411 15.815s-9.032-.96-12.917 11.654c-4.623 15.037 8.532 22.813 8.532 22.813s-5.156 1.629-2.844 5.513c1.644 2.757 8.452 5.815 12.257 7.348-20.796 32.37-9.246 69.888 1.93 75.504-.699 5.362 6.593 15.116 15.649 23.513-11.407 2.192-17.158 12.63-16.61 25.594.183-11.963 15.649-19.907 18.103-19.374 7.15 9.865 16.976 7.625 16.976 7.625 2.089-5.401 1.557-6.14 3.066-12.884 7.991-5.95 13.043-18.366 6.847-27.032-1.572-2.407-2.462-3.726-3.225-6.101 13.6-1.652 33.482-17.69 32.91-37.501-.905-31.29 31.298-25.809 31.298-25.809s.087-6.228-2.24-10.7c5.092 2.145 6.601 11.026 6.601 11.026s18.834-6.371 31.687 31.282c1.184 3.479.953 14.361.477 19.803-4.544 5.719 1.795 21.503-2.328 37.867 27.143 24.601-4.591 30.305.763 46.843 1.136 3.972 3.892 7.34 6.45 10.398 1.684 2.042 3.249 4.202 3.876 6.76.628 2.558.072 5.283-.842 7.777 6.165-12.734-8.793-17.246-8.039-29.042.692-5.163 15.173-9.564 16.046-24.998.533-9.366-6.513-18.604-8.73-23.108-5.568-22.973 22.06-15.196 6.546-66.948l-.024-.024Zm-112.131 61.753c1.604 6.14-.572 12.233-5.608 15.53-11.805-1.962-43.515-30.837-21.694-46.224 8.928-6.299 17.356 11.661 18.111 13.321-1.152.199-8.086-.19-9.755 3.893-1.398 4.496 3.059 11.987 7.658 11.836-3.94-3.829-5.894-11.32 3.614-11.86 1.796 5.878 6.053 7.912 7.674 13.512v-.008Zm19.048-35.571c-2.478 5.918-7.188 10.469-12.717 13.551-3.003 1.708-6.292 2.741-9.683 3.512-.151-1.216 18.365-20.193 24.188-21.702a73.962 73.962 0 0 1-1.788 4.639Z"
          fill={c.hair}
        />
      </G>
      <Defs>
        <ClipPath id="clip0_2446_10798">
          <Rect width={303.667} height={303.667} fill="#fff" />
        </ClipPath>
      </Defs>
    </Svg>
  );
};
